// Module-level router singleton. Kept separate from '@/router' so consumers
// shipped in the main bundle (e.g. AppLink) don't pull vue-router and the
// route registry in — those load only with mountRouterApp.
//
// Why not useRouter()? It reads an app-level injection, so it only works
// inside apps created with app.use(router) — on every non-router page it
// returns undefined and logs an inject warning per component instance. This
// probe is injection-free and safe to call from globally registered
// components on any page.
import { ref } from 'vue'

let router = null

// Name of the catch-all route matching every path no opted-in feature claims.
// It exists so router.resolve() can classify arbitrary hrefs without dev
// warnings; navigating to it means a full page load (see router guards).
export const FALLBACK_ROUTE = 'full-page-load'

// True when the initial navigation failed. A failure on a freshly served URL
// never auto-reloads (Rails just answered for this exact URL — retrying can't
// help, only loop); RouterShell renders a manual retry alert instead. Reset
// by the next successful navigation.
export const navigationFailed = ref(false)

export function setRouter(r) {
  router = r
}

// Returns null on pages that mounted without the router shell.
export function getRouter() {
  return router
}

// Programmatic counterpart of AppLink: client-side navigation when the path
// is claimed by a registered route, full page load otherwise. Use it for
// post-save/redirect flows in code shared between routed and non-routed pages.
export function navigateTo(path) {
  const resolved = router?.resolve(path)
  if (resolved && resolved.matched.length > 0 && resolved.name !== FALLBACK_ROUTE) {
    return router.push(path)
  }

  window.location.assign(path)
  return null
}
